export default function MessageInput({ input, setInput, sendMessage }) {
	return (
		<div className="p-3 bg-white border-t flex gap-2">
			<input
				value={input}
				onChange={(e) => setInput(e.target.value)}
				onKeyDown={(e) => e.key === "Enter" && sendMessage()}
				className="flex-1 px-4 py-2 bg-gray-100 rounded-full"
				placeholder="Type message..."
			/>
			<button
				onClick={sendMessage}
				className="bg-[#0b5cff] text-white px-5 py-2 rounded-full"
			>
				Send
			</button>
		</div>
	);
}
